module.exports = __webpack_public_path__ + "img/desjardins_complexe.0b8f9a71.png";